import { DependencyList, RefObject, useEffect } from 'react'

export const useIntersectionObserver = <T extends HTMLElement>(
  refOrElement: HTMLElement | RefObject<T | Array<T | null>> | null,
  callback: IntersectionObserverCallback,
  options?: IntersectionObserverInit,
  when?: boolean,
  deps?: DependencyList
): void =>
  useEffect((): (() => void) => {
    const observer = new IntersectionObserver(callback, options)
    if ((when == undefined || when) && refOrElement != null) {
      if (refOrElement instanceof HTMLElement) observer.observe(refOrElement)
      else if (refOrElement.current) {
        if (Array.isArray(refOrElement.current))
          refOrElement.current.forEach((item) => {
            if (item) observer.observe(item)
          })
        else observer.observe(refOrElement.current)
      }
    }
    return (): void => {
      if (refOrElement != null) {
        if (refOrElement instanceof HTMLElement) observer.unobserve(refOrElement)
        else {
          if (refOrElement.current) {
            if (Array.isArray(refOrElement.current))
              refOrElement.current.forEach((item): void => {
                if (item) observer.unobserve(item)
              })
            else observer.unobserve(refOrElement.current)
          }
        }
      }
      observer.disconnect()
    }
  }, [...(deps || []), when])
